module.exports = __webpack_public_path__ + "static/colleen-rowan-5d93d0e50c88bd60f0f7894c9ae8b1b9.jpg";